<div>
  Your subscription will end on
  {{ seconds * 1000 | date }}
</div>
